module.exports = __webpack_public_path__ + "static/media/vodafone.bac02ce1.png";